import { render, staticRenderFns } from "./ProductPeriodList.vue?vue&type=template&id=69346be8&scoped=true&"
import script from "./ProductPeriodList.vue?vue&type=script&lang=js&"
export * from "./ProductPeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69346be8",
  null
  
)

export default component.exports